<div [id]="htmlId()" class="authentication-wrapper">
  <div [ngClass]="['authentication-text', properties.style.toLowerCase(), 'preserve-newlines']" [style]="textStyle()">
    {{ properties.text }}
  </div>
  @if (properties.groupItems && !formValueSignal()) {
    <div class="authentication-user-role">{{ properties.groupItems.join(' / ') }}</div>
  }

  @if (!formValueSignal()) {
    <button
      type="button"
      role="button"
      class="authentication-opener"
      (click)="onSignatureClick()"
      [disabled]="!canSign() || formControl?.disabled">
      <div class="icon-safe-zone">
        <mat-icon class="icon">verified_user</mat-icon>
      </div>
      <span>{{ properties.label }}</span>
    </button>
  }

  @if (formValueSignal()) {
    <div class="authentication-result">
      @if (!formControl?.disabled) {
        <button class="control" type="button" role="button" (click)="resetSignature()">
          <div class="icon">
            <mat-icon>delete</mat-icon>
          </div>
        </button>
      }
      <div class="authentication-user">{{ signatureInfo() }}</div>
    </div>
  }
</div>
